import { Overline } from "@amber/ui";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "de", label: "German" },
  { code: "fr", label: "French" },
] as const;

export function Languages({
  value,
  onChange,
  invalid,
}: {
  value: readonly string[];
  onChange: (next: string[]) => void;
  invalid: boolean;
}) {
  return (
    <fieldset className="m-0 mt-3 border-0 p-0">
      <Overline as="legend" className="mb-1.5">
        Languages to monitor <span className="font-medium normal-case tracking-normal text-attention">required</span>
      </Overline>
      <div className="flex flex-wrap gap-3">
        {LANGUAGES.map((l) => (
          <label key={l.code} className="flex items-center gap-1.5">
            <input
              type="checkbox"
              className="accent-[var(--color-link)]"
              checked={value.includes(l.code)}
              onChange={(e) => {
                onChange(e.target.checked ? [...value, l.code] : value.filter((v) => v !== l.code));
              }}
            />
            {l.label}
          </label>
        ))}
      </div>
      {invalid ? <p className="m-0 mt-1.5 text-md text-attention">Choose at least one language</p> : null}
    </fieldset>
  );
}
